/**
 * @desc 根据单据号导出文件
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.rms.expenseReimbursement.exportFile.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/exportFile`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
